import { type TextareaHTMLAttributes, forwardRef } from "react";
import { cn } from "./utils/cn";

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ invalid, className, ...rest }, ref) => (
    <textarea
      ref={ref}
      className={cn("hui-textarea", invalid && "hui-textarea--error", className)}
      {...rest}
    />
  )
);

TextArea.displayName = "TextArea";
